import { IDropdownItem } from '../VPDropdown';

export enum FilterType {
    Multiselect = 'multiselect',
    DateRange = 'dateRange',
    TextField = 'textField',
}

interface BaseFilterConfig {
    key: string;
    disabled?: boolean;
}

export interface MultiselectFilterConfig extends BaseFilterConfig {
    type: FilterType.Multiselect;
    label: string;
    items: IDropdownItem[];
    selectedValues: any[];
    searchable?: boolean;
    toggleable?: boolean;
    toggleText?: string;
    toggleStatus?: boolean;
    onToggleChange?: (checked: boolean) => void;
    sortItemsByValue?: boolean;
}

export interface DateRangeFilterConfig extends BaseFilterConfig {
    type: FilterType.DateRange;
    startDate: moment.Moment | Date | undefined;
    endDate: moment.Moment | Date | undefined;
    maxDays?: number;
    onDateRangeApply: (startDate: moment.Moment | Date | undefined, endDate: moment.Moment | Date | undefined) => void;
}

export interface TextFieldFilterConfig extends BaseFilterConfig {
    type: FilterType.TextField;
    label: string;
    value: string;
    placeholder?: string;
    onClear: () => void;
}

export type FilterConfig = MultiselectFilterConfig | DateRangeFilterConfig | TextFieldFilterConfig;

export interface FilterState {
    [key: string]: any;
}

export interface IConfigurableFilterBarSlotProps {
    desktop?: {
        right?: React.ReactNode;
    };
    mobile?: {
        left?: React.ReactNode;
        right?: React.ReactNode;
    };
}

export interface IConfigurableFilterBarMobileProps {
    drawerIsOpen: boolean;
    onCloseDrawer: () => void;
    drawerTitle: string;
}

export interface IConfigurableFilterBarProps {
    filters: FilterConfig[];
    isMobileView?: boolean;
    disabled?: boolean;
    onFilterChange: (filterKey: string, value: any) => void;
    onMobileViewChange?: (isMobileView: boolean) => void;
    slotProps?: IConfigurableFilterBarSlotProps;
    mobileProps?: IConfigurableFilterBarMobileProps;
}
